import { TableCell, TableRow, Typography } from '@mui/material';
import { EventCallsDto, IPagingData } from '@sr/dto';
import { GridLayout } from 'shared/ui/grid-layout';
import { IRemotePagedCollection } from 'utils/remote-paged-collection.hook';
import { LinkToCompany } from 'shared/ui/links/link-to-company';
import { formatDate } from 'utils/date-format-helpers';
import { formatPhone } from 'utils/phone-format-helpers';
import AudioPlayer from 'entities/audio-player/audio-player';
import { CALL_TYPE_MAP } from '@sr/dto/dist/src/enums/events';


type Props = {
  collection: IRemotePagedCollection<EventCallsDto>,
  paging?: IPagingData;
  onChangePaging?: (paging: IPagingData) => void;
};

export const CallsList = ({ collection, paging, onChangePaging }: Props) => {

  return (
    <>
      <GridLayout<EventCallsDto>
        columns={['Телефон от', 'Телефон куда', 'Компания', 'Менеджер', 'Длительность, сек', 'Направление', 'Дата', 'Запись']}
        items={collection.collection.items}
        totalItemsCount={collection.collection.totalItemsCount}
        isLoading={collection.isLoading}
        error={collection.error}
        pagingData={paging}
        onChangePaging={onChangePaging}
        itemRender={(item) =>
          <CallsList.Row
            key={item.id}
            row={item}
          />}
        noItemsText='Список звонков пуст'
      />
    </>);
};


type RowProps = {
  row: EventCallsDto
};

CallsList.Row = (props: RowProps) => {
  const { row } = props;

  return (
    <TableRow>
      <TableCell align="left">
        {formatPhone(row.fromPhone?.phone)}
      </TableCell>
      <TableCell align="left">
        {formatPhone(row.toPhone?.phone)}
      </TableCell>
      <TableCell align="left">
        <LinkToCompany company={row.company} />
      </TableCell>
      <TableCell align="left">
        {row.user ? `${row.user.firstName} ${row.user.secondName}`.trim() : '-'}
      </TableCell>
      <TableCell align="left">
        {row.atsDuration}
      </TableCell>
      <TableCell align="left">
        {CALL_TYPE_MAP[row.taskType as keyof typeof CALL_TYPE_MAP] || row.taskType}
      </TableCell>
      <TableCell align="left">
        {formatDate(row.createdAt)}
      </TableCell>
      <TableCell align="left">
        {row.atsAudioLink ? (
          <AudioPlayer audioUrl={row.atsAudioLink} />
        ) : (
          <Typography variant="body2" color="textSecondary">
      Нет записи
          </Typography>
        )}
      </TableCell>
    </TableRow>);
};
